export const pageLocation = (defaultLocation = 'other'): string => {
  let location = defaultLocation;
  if (window.location.pathname === '/') location = 'homepage';
  if (window.location.pathname.includes('/products/')) location = 'pdp';
  if (window.location.pathname.includes('/blogs/')) location = 'stack';
  if (window.location.pathname.includes('/pages')) location = `page-${window.location.pathname.substring(7)}`;
  if (window.location.pathname === '/account') location = 'my-account';
  if (window.location.pathname === '/cart') location = 'cart';
  if (window.location.pathname.includes('/checkouts/')) location = 'checkout';
  return location;
};
